/** Holidays admin: form <-> payload and checks (pure, no React). */

export const HOLIDAY_TYPES = [
  "REGULAR",
  "SPECIAL_NON_WORKING",
  "SPECIAL_WORKING",
  "COMPANY",
];
// companyId in the form: NATIONAL = every company (super admin), "" = my company
export const NATIONAL = "__national__";
export const NAME_MAX = 120;
export const REMARKS_MAX = 500;

export const SKIP_REASON = {
  MOVABLE: "Date changes every year: add it yourself",
  EXISTS: "Already there",
  NO_FEB_29: "No Feb 29 that year",
};

export const emptyForm = (year) => ({
  date: year ? `${year}-01-01` : "",
  name: "",
  type: "REGULAR",
  companyId: "",
  branchIds: [],
  remarks: "",
  isDraft: false,
});

export const fromRow = (row) => ({
  date: row.date || "",
  name: row.name || "",
  type: row.type || "REGULAR",
  companyId: row.companyId === null ? NATIONAL : row.companyId || "",
  branchIds: row.branchIds || [],
  remarks: row.remarks || "",
  isDraft: !!row.isDraft,
});

export const formProblems = (f) => {
  const p = [];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(f.date)) p.push("Pick the date.");
  if (!f.name.trim()) p.push("Add the holiday's name.");
  if (f.name.length > NAME_MAX)
    p.push(`The name is too long (max ${NAME_MAX} characters).`);
  if (f.type === "COMPANY" && f.companyId === NATIONAL)
    p.push("A company holiday needs a company, not every company.");
  if (f.remarks.length > REMARKS_MAX)
    p.push(`The remarks are too long (max ${REMARKS_MAX} characters).`);
  return p;
};

export const toPayload = (f) => {
  const body = {
    date: f.date,
    name: f.name.trim(),
    type: f.type,
    branchIds: f.companyId === NATIONAL ? [] : f.branchIds,
    remarks: f.remarks.trim() || null,
    isDraft: !!f.isDraft,
  };
  if (f.companyId === NATIONAL) body.companyId = null;
  else if (f.companyId) body.companyId = f.companyId;
  return body;
};

/** "National", the company, or the branches. */
export const appliesTo = (row) => {
  if (row.scope === "NATIONAL" || row.companyId === null)
    return "Every company";
  if (row.branchIds?.length)
    return `${row.companyName || "Company"} · ${row.branchIds.length} branch${row.branchIds.length === 1 ? "" : "es"}`;
  return row.companyName || "Company";
};
